import styled from "styled-components";

export const SidebarWrapper = styled.div`
  
  margin:0 auto;
  background: #F9F9F9; 
  padding:10px;
  border-radius:10px;
  
ul{
display:flex;
margin-bottom:0;
gap:20px;
    li{
        background: #498ee1;
         border-radius: 5px;        
         gap: 8px;
         align-items: center;
         padding: 13px;
         color: #ffff;
         margin-bottom: 0px;
         border: 1px solid transparent;
         transition: all .3s;
         display:flex;
         span{
            display: block;
            font-size: 15px;
            font-weight: 600;
            width: 100%;
            visibility: visible;
            opacity: 1;
            white-space: nowrap;
         }
         &:hover{
            box-shadow: 0px 1px 2px #00000017;
border: 1px solid #26B9DB;
         }
         &.active{
          background-color: #02a86b;
          color: #fff;
          img{
            
          }
         }
    }
}

&.close{
   min-width: 80px;
   width: 80px;
   overflow: hidden;
   transition: all .3s;
   ul li {
    justify-content: center;
    span{
      visibility: hidden;
      opacity: 0;
      display: none;
    
   }
   }
   @media only screen and (max-width: 768px)  {

   min-width: 232px;
   width: 232px;
   left: -244px;
   overflow: hidden;
   ul li {
  justify-content: start;
    span{
    display: block;
   }
 
}
}
}

`;